export function useScoreOperations(setScore, setIsMuted, markCardAsReviewed, trackStudyActivity) {
  const updateScore = (correct, cardId) => {
    setScore(prev => ({
      total: prev.total + (correct ? 1 : -1),
      right: prev.right + (correct ? 1 : 0),
      wrong: prev.wrong + (correct ? 0 : 1)
    }));
    trackStudyActivity();
    if (cardId !== undefined && cardId !== null) {
      markCardAsReviewed(cardId, correct);
    }
  };

  const toggleMute = () => {
    setIsMuted(prev => !prev);
  };

  return {
    updateScore,
    toggleMute
  };
}
